import React from 'react';
import PurchaseInvoiceForm from './PurchaseInvoiceForm'; // Adjust path

const NewPurchaseInvoicePage = () => {
    return <PurchaseInvoiceForm formType="create" currentInvoiceId={null} />;
};
export default NewPurchaseInvoicePage;